import { ReactComponent as FlagIcon } from "./svg/bn-flag.svg";
import "../flag-icon.scss";

export const BNFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
